<template>
  <base-page-layout title="Desempenho" use-new-filters :filters="['lojas', 'segmentos']">
    <div class="d-flex flex-column desempenho">
      <faturamento-chart />
      <cupons-chart />
      <ticket-medio-chart />
      <media-itens-cesta-chart />
      <cadastros-chart />
    </div>
  </base-page-layout>
</template>

<script>
import BasePageLayout from '@/components/BasePageLayout.vue'
import CadastrosChart from '@/modules/empresa/desempenho/views/pages/CadastrosChart.vue'
import FaturamentoChart from '@/modules/empresa/desempenho/views/pages/FaturamentoChart.vue'
import MediaItensCestaChart from '@/modules/empresa/desempenho/views/pages/MediaItensCestaChart.vue'
import TicketMedioChart from '@/modules/empresa/desempenho/views/pages/TicketMedioChart.vue'
import CuponsChart from '@/modules/empresa/desempenho/views/pages/CuponsChart.vue'

export default {
  components: {
    BasePageLayout,
    CadastrosChart,
    CuponsChart,
    FaturamentoChart,
    MediaItensCestaChart,
    TicketMedioChart,
  },
}
</script>

<style lang="scss" scoped>
.desempenho {
  gap: 12px;
}
</style>
